import {Directive, ElementRef, EventEmitter, Inject, Optional, Output, SkipSelf} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ERROR_COLLECTOR_SOURCE, ErrorCollection} from '../../util/ErrorCollection';
import {VALIDATION_CONTEXT_REFLECTION} from '../context/validation-named-context-base.directive';
import {VALIDATION_CONTEXT_LOCAL} from '../context/validation-common-context.directive';
import {ValidationCheckBaseDirective, ValidationSubmitEvent} from './validation-check-base.directive';
import {ValidationContext} from '../../data/validation-context';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[onValid],[onInvalid],[onValidated]'
})
export class ValidationCheckSubmitDirective extends ValidationCheckBaseDirective {
    constructor(
        $element: ElementRef,
        @Inject(ERROR_COLLECTOR_SOURCE) @SkipSelf() @Optional()
        $errorCollection: ErrorCollection,
        @Inject(VALIDATION_CONTEXT_REFLECTION) @SkipSelf() @Optional()
        $globalContext: ValidationContext,
        @Inject(VALIDATION_CONTEXT_LOCAL) @SkipSelf() @Optional()
        $localContext: ValidationContext,
        $ngForm: NgForm,
    ) {
        super($element, $errorCollection, $globalContext, $localContext, $ngForm);
    }

    protected performSubmit(): void {
        // This submit is required to update all ngModels and validate form.
        this.ngForm.onSubmit(new CustomEvent('submit'));
        // In this scenario fields are not marked as dirty, that is not required.
    }

    @Output()
    public get onValid(): EventEmitter<ValidationSubmitEvent> {
        return this.onValid$;
    }

    @Output()
    public get onInvalid(): EventEmitter<ValidationSubmitEvent> {
        return this.onInvalid$;
    }

    @Output()
    public get onValidated(): EventEmitter<ValidationSubmitEvent> {
        return this.onValidated$;
    }
}
